import React from 'react';

import { Flex } from '../../components/common/atom/Layout';
import { HorizonGreyLine } from '../../components/common/atom/HorizonGreyLine';
import { Text } from '../../components/common/atom/Text';
import { Padding } from '../../components/common/atom/Padding';
import { EmptyMessage } from '../../components/common/organism/EmptyMessage';

import FriendPaybackListItem from './FriendPaybackListItem';

const FriendPaybackList = ({ data: paybackList }) => {
  return paybackList.length > 0 ? (
    <Flex column>
      <Flex column alignItems="stretch" padding="1.25rem" width="100%">
        <Text weight="medium" style={{ marginBottom: '0.625rem' }}>
          {LANG.titleFriendPaybackInfo}
        </Text>
        {FRIENDPAYBACK_INFO.map((info) => (
          <Text key={info.text} size={12} lineHeight="1rem">
            {`* ${info.text}`}
          </Text>
        ))}
      </Flex>
      <HorizonGreyLine />
      {paybackList.map((payback) => (
        <FriendPaybackListItem key={payback.id} item={payback} />
      ))}
    </Flex>
  ) : (
    <Padding top={20} left={20} right={20}>
      <EmptyMessage
        messageList={[
          '베이비페이스 분석이 완료된 후에 코드가 발급됩니다.',
          '베이비페이스의 가슴 벅찬 경험을 친구와 함께 나누세요!',
        ]}
      />
    </Padding>
  );
};

export default FriendPaybackList;

const LANG = {
  titleFriendPaybackInfo: '친구추천코드 안내사항',
  textRegisteredCount: '등록 개수 : 타인이 추천 코드를 등록함',
  textUsedCount: '사용 개수 : 타인이 추천 코드로 분석까지 완료함',
  textCopyToClipboard: '친구추천코드를 클릭하면 클립보드에 코드가 복사됩니다.',
};

const FRIENDPAYBACK_INFO = [
  { text: LANG.textRegisteredCount },
  { text: LANG.textUsedCount },
  { text: LANG.textCopyToClipboard },
];
